"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStore = void 0;
const jwt_decode_1 = require("jwt-decode");
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const Logger_1 = require("./Logger");
// Defaults
const DEFAULT_TOKEN_NAME = "FOXSSOACCT";
const PREPROD_TOKEN_NAME = "qFOXSSOACCT";
const DEFAULT_AUTH_OPTIONS = {
    name: DEFAULT_TOKEN_NAME,
    path: "/",
    preProd: false,
    secure: true,
};
// Auth (simple sso)
// Only reads the Auth Cookie - does not modify it
class Auth {
    constructor() {
        this.options = DEFAULT_AUTH_OPTIONS;
        this.store = new universal_cookie_1.default();
    }
    configure(config = {}) {
        var _a;
        this.options = Object.assign({}, this.options, config);
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.preProd) {
            this.options.name = PREPROD_TOKEN_NAME;
        }
        this.loadCookie();
        return this.token;
    }
    getToken() {
        return this.token;
    }
    setToken(token) {
        var _a;
        try {
            if (token && ((_a = this.options) === null || _a === void 0 ? void 0 : _a.name)) {
                if (token === null || token === void 0 ? void 0 : token.accessToken) {
                    this.jwt = (0, jwt_decode_1.jwtDecode)(token === null || token === void 0 ? void 0 : token.accessToken);
                }
                this.token = token;
            }
        }
        catch (error) {
            (0, Logger_1.logError)(error);
        }
    }
    removeToken() {
        this.token = undefined;
        this.jwt = undefined;
        return undefined;
    }
    getMvpdId() {
        var _a;
        return (_a = this.jwt) === null || _a === void 0 ? void 0 : _a.mvpdid;
    }
    getUserId() {
        var _a;
        return (_a = this.jwt) === null || _a === void 0 ? void 0 : _a.uid;
    }
    getDeviceId() {
        var _a;
        return (_a = this.jwt) === null || _a === void 0 ? void 0 : _a.did;
    }
    getUserType() {
        var _a;
        return (_a = this.jwt) === null || _a === void 0 ? void 0 : _a.utype;
    }
    getDeviceType() {
        var _a;
        return (_a = this.jwt) === null || _a === void 0 ? void 0 : _a.dtype;
    }
    getAccountType() {
        var _a;
        return (_a = this.jwt) === null || _a === void 0 ? void 0 : _a.atype;
    }
    getAccessToken() {
        var _a;
        return (_a = this.token) === null || _a === void 0 ? void 0 : _a.accessToken;
    }
    getMvpdAccessToken() {
        var _a;
        if (this.isMvpdUser()) {
            return (_a = this.token) === null || _a === void 0 ? void 0 : _a.accessToken;
        }
        return undefined;
    }
    getNonAnonAccessToken() {
        var _a;
        if (this.isNonAnonymousUser()) {
            return (_a = this.token) === null || _a === void 0 ? void 0 : _a.accessToken;
        }
        return undefined;
    }
    getAnonDeviceId() {
        const isAnon = this.isAnonymousUser();
        const deviceId = this.getDeviceId();
        if (isAnon) {
            return deviceId;
        }
        return undefined;
    }
    isAnonymousUser() {
        var _a;
        return !!((_a = this.jwt) === null || _a === void 0 ? void 0 : _a.atype) && this.jwt.atype === "anonymous";
    }
    isNonAnonymousUser() {
        var _a;
        return !!((_a = this.jwt) === null || _a === void 0 ? void 0 : _a.atype) && this.jwt.atype !== "anonymous";
    }
    isMvpdUser() {
        return this.isAnonymousUser() && !!this.getMvpdId();
    }
    // todo: remove this method once `isNonAnonymousUser` is implemented on client.
    isUserSignedIn() {
        return this.isNonAnonymousUser();
    }
    loadCookie() {
        var _a;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.name) {
            const token = this.store.get(this.options.name);
            this.setToken(token);
        }
    }
}
const AuthStore = new Auth();
exports.AuthStore = AuthStore;
//# sourceMappingURL=Auth.js.map